export const CONFIRMATION_DIALOG__DELETE_SITE_TEXT = 'CONFIRMATION_DIALOG__DELETE_SITE_TEXT';
